import { render, staticRenderFns } from "./GradeFeeDetail.vue?vue&type=template&id=2cb2fa24"
import script from "../../controllers/grade_fee/grade-fee-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/grade_fee/grade-fee-detail.js?vue&type=script&lang=js&external"
import style0 from "./GradeFeeDetail.vue?vue&type=style&index=0&id=2cb2fa24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports